import * as React from 'react';
import { Container, Spacer } from '@nextui-org/react';

import { useSession } from 'next-auth/react';
import { AppUnauthorized } from '@src/layouts/app/AppUnauthorized';
import { AssetCardList } from '@src/layouts/feed/AssetCardList';
import { AssetFilters } from '@src/layouts/feed/AssetFilters';

interface FeedPageProps {}

/**
 * @name FeedPage
 * @description The FeedPage page.
 */
export default function FeedPage(_props: FeedPageProps) {
  // const { } = props;

  // Hooks
  const { status } = useSession();

  if (status === 'unauthenticated') {
    return <AppUnauthorized />;
  }

  return (
    <Container gap={0} md>
      <Spacer />
      <AssetFilters />
      <AssetCardList />
      <Spacer />
    </Container>
  );
}
